import styled from "@emotion/styled";
import theme from "@theme";
import InnoIcons from "InnoUI/innoicons";

const BodyHeader = styled.div`
  padding: 15px 20px;
  background-color: #f7f9f7;
  border-bottom: 1px solid ${theme.colors.bordertask};
  position: fixed;
  width: 100%;
  z-index: 1000;
`;

const BodyContainer = styled.div`
  margin-top: 50px;
`;

const Container = styled.div`
  display: flex;
  width: 100%;
  min-width: 0;
`;

const HeadingTag = styled.p`
  float: left;
  margin: 5px;
  padding: 0px 20px 0px 0px;
  font-weight: bold;
`;

const ValueSpan = styled.span`
  color: ${theme.colors.black};
  font-size: 13px;
  opacity: 0.7;
`;
const ValueSpanP = styled.span`
  color: ${theme.colors.black};
  font-size: 13px;
  opacity: 0.7;
  cursor: pointer;
`;
const InputContiner = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  width: 40%;
`;

const SearchIcon = styled(InnoIcons.SearchIcon)`
  position: absolute;
  left: 10px;
  color: #afafaf;
  font-size: 20px;
`;

const InputStyle = styled.input`
  width: 100%;
  height: 35px;
  padding: 8px 8px 8px 35px;
  font-size: 13px;
  border: 1px solid ${theme.colors.themeColor};
  border-radius: 5px;
  &:focus {
    outline: none;
    border-color: #ccc;
  }
  ,
  &::placeholder {
    color: #afafaf;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 30px;
  padding-right: 20px;
`;

const TemplateNameContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 50px;
  padding: 20px 20px 10px 20px;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  justify-content: space-between;
  border-bottom: 1px solid ${theme.colors.bordertask};
  text-align: center;
  gap: 12px;
  flex-wrap: wrap;
`;

const ArrowBackIcon = styled(InnoIcons.ArrowBackIcon)`
  cursor: pointer;
  font-size: 20px;
`;

const TemplateName = styled.p`
  font-size: 20px;
  margin: 0 20px 0 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 400;
`;

const PermissionContainer = styled.div`
  flex: 1;
`;
const FolderContainer = styled.div`
  flex: 1;
  min-width: 0;
`;

const PChildren = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0px 20px 0px 20px;
`;

const PermissionSpan = styled.span`
  padding: 8px 0px 0px 0px;
  font-weight: bold;
  color: ${theme.colors.themeColor};
`;

const SelectSpan = styled.span`
  padding: 8px 0px 0px 0px;
  color: ${theme.colors.darkBlue};
  margin-left: 10px;
`;

const RolePermissionsContainer = styled.div`
  margin: 0px 15px 15px 15px;
  align-items: center;
`;

const FChildren = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0px 15px 0px 0px;
  justify-content: space-between;
`;

const FolderSpan = styled.span`
  padding: 8px 0px 0px 10px;
  color: ${theme.colors.themeColor};
  font-weight: bold;
`;

const FolderStructureContainer = styled.div`
  padding: 10px;
  border: 1px solid ${theme.colors.bordertask};
  margin: 5px 15px 10px 10px;
  border-radius: 5px;
  max-height: calc(100vh - 200px);
  overflow-x: auto;
  overflow-y: auto;
  box-sizing: border-box;
  min-width: 0;

  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  &::-webkit-scrollbar-thumb {
    background: ${theme.colors.bordertask};
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: ${theme.colors.themeColor};
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
`;

const SC = {
  Container,
  BodyHeader,
  BodyContainer,
  HeadingTag,
  ValueSpan,
  ValueSpanP,
  InputContiner,
  SearchIcon,
  InputStyle,
  ButtonContainer,
  TemplateNameContainer,
  ArrowBackIcon,
  TemplateName,
  PermissionContainer,
  FolderContainer,
  PChildren,
  PermissionSpan,
  SelectSpan,
  RolePermissionsContainer,
  FChildren,
  FolderSpan,
  FolderStructureContainer,
};

export default SC;
